import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col md:flex-row gap-4 md:gap-16 w-full py-3 pr-0 md:pr-24" }
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col flex-1 rounded-lg overflow-hidden bg-[#F0F0F4]"
}
const _hoisted_3 = { class: "flex flex-col text-left" }
const _hoisted_4 = {
  key: 1,
  class: "w-4 h-4 mt-1"
}
const _hoisted_5 = { class: "flex flex-col text-left" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col gap-1 text-left p-4"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-sm text-[#212529]" }, "Modalidade de repasse", -1)
const _hoisted_8 = { class: "text-sm text-[#212529]" }
const _hoisted_9 = { class: "flex flex-col flex-1 rounded-lg overflow-hidden bg-[#F0F0F4]" }
const _hoisted_10 = { class: "flex flex-col text-left" }
const _hoisted_11 = {
  key: 1,
  class: "w-4 h-4 mt-1"
}
const _hoisted_12 = {
  key: 2,
  class: "flex flex-col text-left"
}
const _hoisted_13 = {
  key: 1,
  class: "flex flex-col gap-1 text-left p-4"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "font-bold text-sm text-[#212529]" }, "Regra de proporcionalidade", -1)
const _hoisted_15 = { class: "text-sm text-[#212529]" }

import { computed } from 'vue'
import SVGIcon from '@/components/SVGIcon.vue'
import { mdiMinusCircleOutline, mdiLockOpenVariant, mdiLock } from '@mdi/js'
import { getProportionalityRuleTitle } from '@/utils/schedule'
import { ProportionalityRuleEnum } from '@/Network/Types/Requests/ScheduleRequests'
import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'

const BG_NEUTRAL = 'bg-[#F0F0F4]'
const BG_HIGHLIGHT = 'bg-[#FCE5E8]'
const TEXT_MUTED = 'text-gray-400'
const TEXT_DEFAULT = 'text-[#212529]'
const TEXT_PRIMARY30 = 'text-primary30'
const TEXT_NEGATIVE = 'text-negative'

type ApprovalStatus = 'Approved' | 'Rejected' | null


export default /*#__PURE__*/_defineComponent({
  __name: 'RepassProportionalityDetailsSection',
  props: {
    originalRepassMode: {},
    currentRepassMode: {},
    originalProportionalityRule: {},
    currentProportionalityRule: {},
    repassModeStatus: {},
    proportionalityRuleStatus: {}
  },
  setup(__props: any) {

const props = __props;



const permissionsStore = usePermissionsStore()

const canReadPaymentRules = computed(() => {
  return permissionsStore.checkAnyRessources({
    permission: AuthorizationPermissions.StationPaymentRulesReading,
    resourceType: AuthorizationResourcesAndSubjects.Schedule
  })
})

const formatRepassMode = (mode?: 'FLOW' | 'IMMEDIATE' | null): string => {
  if (mode === 'FLOW') return 'Fluxo'
  if (mode === 'IMMEDIATE') return 'À vista'
  return 'Não definida'
}

const repassOriginalContainerClasses = computed(() => {
  if (props.repassModeStatus === 'Approved') return BG_NEUTRAL
  if (props.repassModeStatus === 'Rejected')
    return 'rounded-lg border-2 border-primary30 bg-[#E2E2E9]'
  return BG_NEUTRAL
})

const repassOriginalTextClasses = computed(() => {
  return props.repassModeStatus === 'Approved' ? TEXT_MUTED : TEXT_DEFAULT
})

const repassOriginalIcon = computed(() => {
  return props.repassModeStatus === 'Rejected' ? mdiLock : mdiMinusCircleOutline
})

const repassOriginalIconClasses = computed(() => {
  if (props.repassModeStatus === 'Approved') return TEXT_MUTED
  if (props.repassModeStatus === 'Rejected') return TEXT_PRIMARY30
  return TEXT_NEGATIVE
})

const repassRequestedContainerClasses = computed(() => {
  if (props.repassModeStatus === 'Approved') return BG_HIGHLIGHT
  if (props.repassModeStatus === 'Rejected') return BG_NEUTRAL
  return BG_HIGHLIGHT
})

const repassRequestedTextClasses = computed(() => {
  return props.repassModeStatus === 'Rejected' ? TEXT_MUTED : TEXT_DEFAULT
})

const repassRequestedValueTextClasses = computed(() => {
  if (props.repassModeStatus === 'Rejected') return TEXT_MUTED
  return TEXT_DEFAULT
})

const repassRequestedIconClasses = computed(() => {
  if (props.repassModeStatus === 'Rejected') return TEXT_MUTED
  return TEXT_NEGATIVE
})

const propRuleOriginalContainerClasses = computed(() => {
  if (props.proportionalityRuleStatus === 'Approved')
    return 'rounded-lg border-2 border-[#F0F0F4] bg-[#F0F0F4]'
  if (props.proportionalityRuleStatus === 'Rejected')
    return 'rounded-lg border-2 border-primary30 bg-[#E2E2E9]'
  return BG_NEUTRAL
})

const propRuleOriginalTextClasses = computed(() => {
  return props.proportionalityRuleStatus === 'Approved' ? TEXT_MUTED : TEXT_DEFAULT
})

const propRuleOriginalIcon = computed(() => {
  return props.proportionalityRuleStatus === 'Rejected' ? mdiLock : mdiMinusCircleOutline
})

const propRuleOriginalIconClasses = computed(() => {
  if (props.proportionalityRuleStatus === 'Approved') return TEXT_MUTED
  if (props.proportionalityRuleStatus === 'Rejected') return TEXT_PRIMARY30
  return TEXT_NEGATIVE
})

const propRuleRequestedContainerClasses = computed(() => {
  if (props.proportionalityRuleStatus === 'Approved') return BG_HIGHLIGHT
  if (props.proportionalityRuleStatus === 'Rejected') return BG_NEUTRAL
  return BG_HIGHLIGHT
})

const propRuleRequestedTextClasses = computed(() => {
  return props.proportionalityRuleStatus === 'Rejected' ? TEXT_MUTED : TEXT_DEFAULT
})

const propRuleRequestedValueTextClasses = computed(() => {
  if (props.proportionalityRuleStatus === 'Rejected') return TEXT_MUTED
  return TEXT_DEFAULT
})

const propRuleRequestedIconClasses = computed(() => {
  if (props.proportionalityRuleStatus === 'Rejected') return TEXT_MUTED
  return TEXT_NEGATIVE
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (canReadPaymentRules.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.originalRepassMode)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["flex items-center gap-2 px-4 h-full", repassOriginalContainerClasses.value])
                }, [
                  _createVNode(SVGIcon, {
                    path: repassOriginalIcon.value,
                    class: _normalizeClass(["w-4 h-4", repassOriginalIconClasses.value])
                  }, null, 8, ["path", "class"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["font-bold text-md", repassOriginalTextClasses.value])
                    }, "Modalidade de repasse", 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-sm", repassOriginalTextClasses.value])
                    }, _toDisplayString(formatRepassMode(_ctx.originalRepassMode)), 3)
                  ])
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass(["flex items-center gap-2 px-4 h-full", repassRequestedContainerClasses.value])
                }, [
                  (_ctx.repassModeStatus !== 'Rejected')
                    ? (_openBlock(), _createBlock(SVGIcon, {
                        key: 0,
                        path: _unref(mdiLockOpenVariant),
                        class: _normalizeClass(["w-4 h-4", repassRequestedIconClasses.value])
                      }, null, 8, ["path", "class"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4)),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["font-bold text-md", repassRequestedTextClasses.value])
                    }, "Modalidade de repasse", 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-sm", repassRequestedValueTextClasses.value])
                    }, _toDisplayString(formatRepassMode(_ctx.currentRepassMode)), 3)
                  ])
                ], 2)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (canReadPaymentRules.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _hoisted_7,
                      _createElementVNode("span", _hoisted_8, _toDisplayString(formatRepassMode(_ctx.currentRepassMode)), 1)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.originalProportionalityRule)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex items-center gap-2 px-4 py-2", propRuleOriginalContainerClasses.value])
            }, [
              _createVNode(SVGIcon, {
                path: propRuleOriginalIcon.value,
                class: _normalizeClass(["w-4 h-4", propRuleOriginalIconClasses.value])
              }, null, 8, ["path", "class"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", {
                  class: _normalizeClass(["font-bold text-md", propRuleOriginalTextClasses.value])
                }, "Regra de proporcionalidade", 2),
                _createElementVNode("span", {
                  class: _normalizeClass(["text-sm", propRuleOriginalTextClasses.value])
                }, _toDisplayString(_unref(getProportionalityRuleTitle)(_ctx.originalProportionalityRule)), 3)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex items-center gap-2 px-4 py-2", propRuleRequestedContainerClasses.value])
            }, [
              (_ctx.proportionalityRuleStatus !== 'Rejected')
                ? (_openBlock(), _createBlock(SVGIcon, {
                    key: 0,
                    path: _unref(mdiLockOpenVariant),
                    class: _normalizeClass(["w-4 h-4", propRuleRequestedIconClasses.value])
                  }, null, 8, ["path", "class"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11)),
              (canReadPaymentRules.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("span", {
                      class: _normalizeClass(["font-bold text-md", propRuleRequestedTextClasses.value])
                    }, "Regra de proporcionalidade", 2),
                    _createElementVNode("span", {
                      class: _normalizeClass(["text-sm", propRuleRequestedValueTextClasses.value])
                    }, _toDisplayString(_unref(getProportionalityRuleTitle)(_ctx.currentProportionalityRule)), 3)
                  ]))
                : _createCommentVNode("", true)
            ], 2)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(getProportionalityRuleTitle)(_ctx.currentProportionalityRule)), 1)
          ]))
    ])
  ]))
}
}

})